module.exports = __webpack_public_path__ + "media/2.d6f3c4e5.mp4";